"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMessageInList = exports.removeFromList = exports.addToList = exports.prepareMessageToStar = void 0;
const prepareMessageToStar = (message, chatInfo) => {
    const messageData = message.getMessage();
    return {
        chatId: messageData.chatId,
        chatType: messageData.chatType,
        createdAt: messageData.createdAt,
        message,
        info: chatInfo,
    };
};
exports.prepareMessageToStar = prepareMessageToStar;
const addToList = (list, message, chatInfo) => {
    const messageToStar = (0, exports.prepareMessageToStar)(message, chatInfo);
    return Object.assign(Object.assign({}, list), { data: [messageToStar, ...list.data], total: list.total ? list.total + 1 : 1 });
};
exports.addToList = addToList;
const removeFromList = (list, message) => {
    const filteredStarMessageList = list.data.filter(starredMessage => { var _a; return ((_a = starredMessage.message) === null || _a === void 0 ? void 0 : _a.getMessage().id) !== message.getMessage().id; });
    return Object.assign(Object.assign({}, list), { data: filteredStarMessageList, total: list.total ? list.total - 1 : 0 });
};
exports.removeFromList = removeFromList;
const updateMessageInList = (list, updatedMessage) => {
    const updatedStarredMessageList = list.data.map((starredMessage) => {
        var _a;
        if (((_a = starredMessage.message) === null || _a === void 0 ? void 0 : _a.getMessage().id) ===
            (updatedMessage === null || updatedMessage === void 0 ? void 0 : updatedMessage.getMessage().id)) {
            return Object.assign(Object.assign({}, starredMessage), { message: updatedMessage });
        }
        else {
            return starredMessage;
        }
    });
    return Object.assign(Object.assign({}, list), { data: [...updatedStarredMessageList] });
};
exports.updateMessageInList = updateMessageInList;
